export class ItemContaEnergia {
    Id: number;
    EmpresaId: number;
    ContaEnergiaId: number;
    TipoLancamentoId: number;
    Kwh: number = 0;
    Valor: number = 0;
    CustoUnitario: number = 0;
}
